const ACCESS_TOKEN = "accessToken";
const REFRESH_TOKEN = "refreshToken";
const EXPIRES_IN = "expiresIn";

export const getAccessToken = () => {
  return window.localStorage.getItem(ACCESS_TOKEN);
};

export const saveAccessToken = (accessToken) => {
  window.localStorage.setItem(ACCESS_TOKEN, accessToken);
};

export const removeAccessToken = () => {
  window.localStorage.removeItem(ACCESS_TOKEN);
};

export const getRefreshToken = () => {
  return window.localStorage.getItem(REFRESH_TOKEN);
};

export const saveRefreshToken = (refreshToken) => {
  window.localStorage.setItem(REFRESH_TOKEN, refreshToken);
};

export const removeRefreshToken = () => {
  window.localStorage.removeItem(REFRESH_TOKEN);
};

export const getExpiresIn = () => {
  return window.localStorage.getItem(EXPIRES_IN);
};

export const saveExpiresIn = (expiresIn) => {
  window.localStorage.setItem(EXPIRES_IN, expiresIn);
};

export const removeExpiresIn = () => {
  window.localStorage.removeItem(EXPIRES_IN);
};

export const getData = (key) => {
  const accessToken = getAccessToken();
  const base64Url = accessToken.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );

  return JSON.parse(jsonPayload)[key] || undefined;
};

export default {
  getAccessToken,
  saveAccessToken,
  removeAccessToken,
  getRefreshToken,
  saveRefreshToken,
  removeRefreshToken,
  getExpiresIn,
  saveExpiresIn,
  removeExpiresIn,
  getData,
};
